<div class="file-input">
  <mat-form-field>
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <input
      (click)="chooseFiles($event)"
      [formControl]="control"
      [value]="fileName ? fileName : ''"
      class="file-input__input"
      matInput
      readonly
      type="text"
    />
    <input
      #fileInput
      (change)="onFileSelected($event)"
      [accept]="availableFormats"
      [multiple]="multipleFiles"
      hidden
      type="file"
    />
    <div *ngIf="!fileName" class="select-file-container" matSuffix>
      <button
        mat-button
        class="select-file-container--select-file"
        (click)="chooseFiles($event)"
      >
        Select file
      </button>
    </div>
    <div *ngIf="fileName" class="link-container" matSuffix>
      <a
        *ngIf="viewCallback"
        class="link-container--link"
        (click)="viewFile()"
        (keydown)="viewFile()"
      >
        View
      </a>
      <a
        *ngIf="!control.disabled"
        class="link-container--link"
        (click)="onRemoveFile()"
        (keydown)="onRemoveFile()"
      >
        Remove
      </a>
    </div>
    <mat-error *ngIf="control?.hasError('fileType')">
      Please attach file with correct extension:
      {{ availableFormatsForErrorMessage }}
    </mat-error>
    <mat-error *ngIf="control?.hasError('maxFileSize')">
      Please attach file with size lower than
      {{ control.errors?.['maxFileSize']?.['maxFileSize'] / 1000000 }} MB
    </mat-error>
  </mat-form-field>
</div>
